export const embedcodeConstants = {
    GETALL_REQUEST: 'EMBEDCODE_GETALL_REQUEST',
    GETALL_SUCCESS: 'EMBEDCODE_GETALL_SUCCESS',
    GETALL_FAILURE: 'EMBEDCODE_GETALL_FAILURE',

    DELETE_REQUEST: 'EMBEDCODE_DELETE_REQUEST',
    DELETE_SUCCESS: 'EMBEDCODE_DELETE_SUCCESS',
    DELETE_FAILURE: 'EMBEDCODE_DELETE_FAILURE'
};
